export const products = [
{
    id: 1,
    name: '7360 7TS ALS® Holster Sig Sauer',
    price: 140.99,
    image: './products images/2017_7365__64836.1546534743__47483.jpg',
    category: 'holsters'
},
{
    id: 2,
    name: 'Rothco Tactical Hard Shell Waterproof Jacket - Black',
    price: 152.99,
    image: './products images/10996-A-amazon.jpg',
    category: 'jackets'
},
{
    id: 3,
    name: 'Blaze Bugout Bag with Hydration - Black',
    price: 325.99,
    image: './products images/MRC9968-MUL_01_360x.webp',
    category: 'backpacks'

},
{
    id: 4,
    name: '7384-SP6-BERETTA ALS® UFA w/ Paddle & Single Strap Leg Shroud Duty Holster',
    price: 180.99,
    image: './products images/7384-SP6__20425.jpg',
    category: 'holsters'
},
{
    id: 5,
    name: ' US Navy Wet Weather Parka ',
    price: 325.99,
    image: './products images/images.jpg',
    category: 'jackets'

},
{
    id: 6,
    name: 'Tactical Knuckle Gloves',
    price: 80.99,
    image: './products images/tactical knuckle gloves.jpg',
    category: 'gloves'

},
{
    id: 7,
    name: 'SOS Survival and Tactical Kit',
    price: 550.89,
    image: './products images/SOS survival and tactical kit.jpg',
    category: 'emergency tools'
},
{
    id: 8,
    name: 'Large Capacity Waterproof Tactical Bag',
    price: 410.15,
    image: './products images/large capacity waterproof tactical bag.jpg',
    category: 'backpacks'
},

{
    id: 9,
    name: 'Rothco Concealed Carry Soft Shell Jacket',
    price: 159.99,
    image: './products images/71I0aTR2BtL._AC_UX385_.jpg',
    category: 'jackets'


},
{
    id: 10,
    name: 'Military Cross-Sling Bags - Black',
    price: 135.45,
    image: './products images/Military cross-sling bags - black.jpg',
    category: 'backpacks'
},
{
    id: 11,
    name: 'M65 US Army Tactical Jacket Waterproof Windbreaker',
    price: 84.99,
    image: './products images/Hde2da6a9d65b4a1b8206f12d6f39236fO.jpg_960x960.webp',
    category: 'jackets'

},
{
    id: 12,
    name: 'Martin boots high top military boots',
    price: 25.99,
    image: './products images/Martin boots high top military boot.jpg',
    category: 'boots'
},
{
    id: 13,
    name: 'Molle Bugout Bag Rucksack Tactical Backpack - Large',
    price: 400.45,
    image: './products images/Molle bugout bag rucksack tactical backpack - large.jpg',
    category: 'backpacks'    
},

{
    id: 14,
    name: 'Rothco Vintage Lightweight M-65 Field Jacket',
    price: 150.79,
    image: './products images/8254-A-amazon.jpg',
    category: 'jackets'


},
{
    id: 15,
    name: '304RDS - Sig Sauer P320 (RED DOT SIGHT) ALS/SLS Holster',
    price: 249.99,
    image: './products images/file_id_c01a0770-632a-4667-93c0-bbc79292dc4d&variant_small__42611.jpg',
    category: 'holsters'


},
{
    id: 16,
    name: 'Extreme Cold Weather Mitten Set',
    price: 80.99,
    image: './products images/Extreme cold weather mitten set.webp',
    category: 'gloves'


},
{
    id: 17,
    name: 'Sig Sauer P320 Full Size with Manual Safety IWB Holster',
    price: 11.99,
    image: './products images/Sig Sauer P320 full size with manual safety IWB holster.jpg',
    category: 'holsters'


},
{
    id: 18,
    name: 'Tactical Emergency Whistle',
    price: 40.89,
    image: './products images/Tactical emergency whistle.jpg',
    category: 'emergency tools'


},
{
    id: 19,
    name: 'Tactical Rubber Knuckle Gloves Fingerless',
    price: 140.99,
    image: './products images/Tactical rubber knuckle gloves fingerless.webp',
    category: 'gloves'


},
{
    id: 20,
    name: 'Military Leather Jungle Boots',
    price: 99.99,
    image: './products images/military leather jungle boots.jpg',
    category: 'boots'


},
{
    id: 21,
    name: 'Tactical Clothing Military Fleece Jacket Army Polar Warm Male Coat Autumn Winter',
    price: 64.99,
    image: './products images/s-l1600.jpg',
    category: 'jackets'

},
{
    id: 22,
    name: 'Military Winter Thermal Fleece Tactical Jacket Outdoors',
    price: 180.45,
    image: './products images/ae728b69fd4656fe24c4aec099107316.jpg',
    category: 'jackets'
},
{
    id: 23,
    name: 'Thigh Gun Holster and Molle Pouch',
    price: 45.85,
    image: './products images/Thigh Gun Holster and molle pouch.jpg',
    category: 'holsters'
},
{
    id: 24,
    name: '3-in-1 Spec Ops Soft Shell Jacket',
    price: 379.99,
    image: './products images/3128-B-amazon.jpg',
    category: 'jackets'
},
{
    id: 25,
    name: 'Tactical Military Waterproof Flashlight',
    price: 89.99,
    image: './products images/Tactical Military waterproof flashlight.webp',
    category: 'emergency tools'
},
{
    id: 26,
    name: 'Fjallraven Anorak N08  waterproof- Dark Olive',
    price: 460.89,
    image: './products images/fjaellraeven-m-anorak-no-8-16b-fjl-83242-dark-grey-1.jpg',
    category: 'jackets'


},
{
    id: 27,
    name: "Hard Knuckle Shooter's Glove",
    price: 24.99,
    image: "./products images/Hard knuckle shooter's glove.webp",
    category: 'gloves'
},
{
    id: 28,
    name: 'M65 Vintage Cold Weather BDU Field Jacket',
    price: 132.79,
    image: './products images/polni-bunda-m65-orig-woodland-n1-velka_1569776854.jpg',
    category: 'jackets'
},
{
    id: 29,
    name: 'M65 Field Jacket Loreng American Army Jacket For Winter',
    price: 110.75,
    image: './products images/H50763b9637a44bcf82566398c99d908fr.jpg_960x960.webp',
    category: 'jackets'


},
{
    id: 30,
    name: 'Defense Tactical Pen Pocket Aviation  - Anti Skid',
    price: 192.69,
    image: './products images/defense tactical pen pocket aviation  - anti skid.jpg',
    category: 'emergency tools'
},
{
    id: 31,
    name: 'Ryno Gear Tactical Combat Boots',
    price: 245.85,
    image: './products images/Ryno gear tactical combat boots.jpg',
    category: 'boots'
},
{
    id: 32,
    name: 'Surplus Jacket M65 Classic 2IN1 - Coyote',
    price: 140.69,
    image: './products images/rab-m-valiance-jacket-22b-rab-qdb-49-army-1.jpg',
    category: 'jackets'
},

{
    id: 33,
    name: 'M17 Military Holster',
    price: 115.25,
    image: './products images/M17 military holster.jpg',
    category: 'holsters'
},
{
    id: 34,
    name: 'Advanced  First Aid Survival Kit Emergency Kit',
    price: 700.45,
    image: './products images/Advanced  First Aid Survival Kit Emergency Kit.jpeg',
    category: 'emergency tools'
},
{
    id: 35,
    name: 'Molle Sport For Hiking Tactical Bag',
    price: 160.75,
    image: './products images/molle sport for hiking tactical bag.jpg',
    category: 'backpacks'
},
{
    id: 36,
    name: 'Tactical Side Zip Boot -Dark Coyote',
    price: 1100.99,
    image: './products images/Tactical side zip boot -dark coyote.jpg',
    category: 'boots'
},
{
    id: 37,
    name: 'Tactical Assault Gloves',
    price: 40.69,
    image: './products images/tactical assault gloves.webp',
    category: 'gloves'
},
{
    id: 38,
    name: 'Delta-Ml-Gen2-Jacket - Brown-Grey',
    price: 269.35,
    image: './products images/74785.jpg',
    category: 'jackets'
},
{
    id: 39,
    name: 'Tactical Drop Leg Holster',
    price: 175.65,
    image: './products images/Tactical Drop Leg Holster.jpg',
    category: 'holsters'
},
{
    id: 40,
    name: 'Under Armour Stellar G2 Side Zip Military Boot',
    price: 190.42,
    image: './products images/Under Armour Stellar G2 side zip Military Boot.jpg',
    category: 'boots'
},
{
    id: 41,
    name: 'Extra Large Molle Tactical Military Backpack Rucksack',
    price: 750.68,
    image: './products images/Extra large molle tactical military backpack rucksack.webp',
    category: 'backpacks'
},
{
    id: 42,
    name: 'Mil Spec Cold Weather Leather Gloves',
    price: 33.85,
    image: './products images/mil spec cold weather leather gloves.webp',
    category: 'gloves'
},
{
    id: 43,
    name: 'Emergency Survival Tactical Kit',
    price: 400.28,
    image: './products images/Emergency survival tactical kit.webp',
    category: 'emergency tools'
},
{
    id: 44,
    name: 'Generic Tactical Waterproof Backpack Rucksack',
    price: 149.95,
    image: './products images/Generic tactical waterproof backpack rucksack.jpg',
    category: 'backpacks'
},
{
    id: 45,
    name: "Rocky Men's Ry008 Military and Tactical Boot",
    price: 201.35,
    image: "./products images/Rocky Men's Ry008 Military and tactical boot.jpg",
    category: 'boots'
},
{
    id: 46,
    name: 'Molle Sport Tactical Bag - Brown',
    price: 179.60,
    image: './products images/Molle sport tactical bag -brown.jpg',
    category: 'backpacks'
},
{
    id: 47,
    name: 'Highland Tactical Roger 2 Backpack.',
    price: 189.65,
    image: './products images/highland tactical roger 2 backpack.webp',
    category: 'backpacks'
},
{
    id: 48,
    name: 'Sig Sauer P320 M17 Pistol Holster',
    price: 54.89,
    image: './products images/Sig sauer P320 m17 pistol Holster.jpg',
    category: 'holsters'
},
{
    id: 49,
    name: 'Military GI Style Aluminum Flashlight',
    price: 144.65,
    image: './products images/military GI style aluminium flashlight.webp',
    category: 'emergency tools'
},
{
    id: 50,
    name: 'Comfort Release Sensitive Skin Pain-Free Removal medical tape',
    price: 19.85,
    image: './products images/Comfort Release Sensitive Skin Pain-Free Removal medical tape.jpg',
    category: 'emergency tools'
},
{
    id: 51,
    name: 'Combat Medic Tape',
    price: 10.25,
    image: './products images/Combat medic tape.jpg',
    category: 'emergency tools'
},
{
    id: 52,
    name: 'Lightweight Combat Boots Suede Leather',
    price: 221.79,
    image: './products images/Lightweight combat boots suede leather.jpg',
    category: 'boots'
},
{
    id: 53,
    name: 'Tactical Trauma Bag IFAK Emergency Pouch',
    price: 40.45,
    image: './products images/Tactical Trauma Bag IFAK Emergency Pouch.jpg',
    category: 'emergency tools'
},
{
    id: 54,
    name: 'Waterproof Tactical Sun UV Protection ',
    price: 99.89,
    image: './products images/HTB1chG_DYSYBuNjSspfq6AZCpXaG.jpg_960x960.webp',
    category: 'jackets'

},
{
    id: 55,
    name: "Men's Tactical Chest Bag",
    price: 54.75,
    image: "./products images/Men's Tactical Chest Bag.webp",
    category: 'backpacks'
},
{
    id: 56,
    name: 'US Navy Weather Tactical Jacket',
    price: 220.,
    image: './products images/s-l300.jpg',
    category: 'jackets'
}
];
